module.exports = __webpack_public_path__ + "static/media/prof.56c018db.png";